import { registerLocaleData } from '@angular/common';
/***
 * @file:
 * @author: haoxianhuan
 * @Date: 2021-07-31 11:13:57
 */
/**
 * æ³¨åäºè§¦åå¨å±äºä»¶
 */
class Monitor {
  events: { [key: string]: any };
  constructor() {
    this.events = {};
  }
  /**
   * æ³¨åäºä»¶
   * @param name äºä»¶åç§°
   * @param fn æ³¨åçäºä»¶
   */
  on(name: string, fn: (...args: any[]) => any) {
    if (!this.events[name]) {
      this.events[name] = [];
    }
    this.events[name].push(fn);
  }
  /**
   * è§¦åäºä»¶
   * @param name äºä»¶åç§°
   * @param args è§¦åäºä»¶çåæ°
   */
  emit(name, ...args: any[]) {
    if (this.events[name]) {
      return this.events[name].map((fn) => fn.apply(this, args));
    } else {
      console.error(`No "${name}" event registered`);
      return [];
    }
  }
  /**
   * å é¤äºä»¶
   * @param name äºä»¶åç§°
   * @param flag æ¯å¦å¨é¨å é¤
   */
  off(name: string, flag: boolean = false) {
    if (flag) {
      this.events = {};
    } else {
      this.events[name] = null;
      delete this.events[name];
    }
  }
}

export default new Monitor();
